import $ from "jquery";
import Marionette from "marionette";
import MenuItemsView from "./MenuItemsView";
import "plugins/tinyscrollbar";
import template from "apps/Menu/menu/view/template/menu.html";


export default Marionette.LayoutView.extend("MenuView", {
    el: "#menu",
    template,
    ui: {
        $items: ".viewport",
        $links: "li"
    },

    events: {
        "click .toggle": "toggleMenu",
        "click .items-toggle": "toggleItems",
        "click .menu-profile": "onClickMenuProfile",
        "click .logout-icon": "onClickLogout"
    },

    initialize(params) {
        params = params || {};
        this.menu = params.menu;
        this.items = params.items;
        this.itemsView = new MenuItemsView({
            collection: this.items,
            menu: this.menu
        });

        this.listenTo(this.itemsView, "go", this.menuGo);

        $(window).on("mousedown", (e) => {
            let target = e.target;
            let $target = $(target);
            let parent = this.el;
            let inside = false;

            if ( target == this.el ) {
                inside = true;
            } else {
                if (
                    $target.hasClass("UserProfileView")
                        || $target.parents(".sub-main-menu, .UserProfileView, .drag-modal.success").length > 0
                ) {
                    return;
                }

                let $parents = $target.parents();
                for (let i = 0, n = $parents.length; i < n; i++) {
                    if ( $parents[i] == parent ) {
                        inside = true;
                        break;
                    }
                }
            }

            if ( inside ) {
                return;
            }

            this.closeMenu();

        });
    },

    menuGo(model, e) {
        this.trigger("go go:" + model.get("id"), model, e);

        if ( model.get("action") != "subMenu" ) {
            this.closeMenu();
        }
    },

    toggleMenu() {
        this.$el.toggleClass("closed");
    },

    closeMenu() {
        this.$el.addClass("closed");
    },

    onRender() {
        this.$el.addClass("theme-background-color");
        this.drawItems();
        this.$el.tinyscrollbar();
    },

    drawItems() {
        this.itemsView.render();
        this.ui.$items.html(this.itemsView.el);
    },

    toggleItems() {
        this.ui.$items.toggleClass("opened");
    },

    onClickMenuProfile() {
        system.apps.channel("UserProfile").trigger("toggle");
    },

    onClickLogout(e) {
        e.preventDefault();
        $.post("/logout", () => {
            location.href = "/";
        });
    }
});
